// extracted by mini-css-extract-plugin
export default {"card":"Xn_xxb","rounded-card":"gXu2Ur","roundedCard":"gXu2Ur","user":"c0CCoL","screenName":"coNzWE","image":"FI09nf","content":"eDuPt0","quote":"Ynp8rC"};